import { Component, Input, model, TemplateRef } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'sb-comp-side-panel',
  templateUrl: './sb-side-panel.component.html',
  styleUrls: ['./sb-side-panel.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [style({ transform: 'translateX(+100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))]),
    ]),
    trigger('fadeAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate(400)]),
      transition(':leave', animate(400, style({ opacity: 0 }))),
    ]),
  ],
  standalone: false,
})
export class SbSidePanelComponent {
  show = model.required<boolean>();
  @Input({ required: true }) width: number;
  @Input() sidebarTemplate: TemplateRef<any>;
  @Input() sidebarHeader: TemplateRef<any>;
  @Input() sidebarFooter: TemplateRef<any>;

  close() {
    this.show.set(false);
  }
}
